export default __webpack_public_path__ + "static/media/SAS0280.34I-39642_-23778_0.a4f279da.jpg";